import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import AirlineService from "services/AirlineService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getAllAirline = createAsyncThunk(
  "airline/getAllAirline",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AirlineService.getAllAirline(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getAllAirlineActive = createAsyncThunk(
  "airline/getAllAirlineActive",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AirlineService.getAllAirlineActive(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createAirline = createAsyncThunk(
  "airline/createAirline",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await AirlineService.createAirline(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateAirline = createAsyncThunk(
  "airline/updateAirline",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await AirlineService.updateAirline(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteAirline = createAsyncThunk(
  "airline/deleteAirline",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const response = await AirlineService.deleteAirline(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  airlineList: [],
  airlineActiveList: [],
};
export const storeAirlineSlice = createSlice({
  name: "airline",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setAirline: (state, action) => {
      state.airlineList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllAirline.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllAirline.fulfilled, (state, action) => {
        state.loading = false;
        state.airlineList = action.payload;
      })
      .addCase(getAllAirline.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getAllAirlineActive.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllAirlineActive.fulfilled, (state, action) => {
        state.loading = false;
        state.airlineActiveList = action.payload;
      })
      .addCase(getAllAirlineActive.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createAirline.pending, (state) => {
        state.loading = true;
      })
      .addCase(createAirline.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createAirline.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateAirline.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAirline.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateAirline.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteAirline.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAirline.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteAirline.rejected, (state, action) => {
        state.loading = false;
      })
      ;
  },
});

export const { showLoading, setAirline } = storeAirlineSlice.actions;

export default storeAirlineSlice.reducer;
